import { Button } from '@design-system/components/button/button';
import { Modal } from '@design-system/components/modal/modal';
import { Typography } from '@design-system/components/typography/typography';
import { Switch } from '@mui/material';
import { useState } from 'react';

export const OneTimeActions = ({
  isExclusive,
  setExclusive,
  submitting,
  visibility,
}: {
  isExclusive: boolean;
  setExclusive: (isExclusive: boolean) => void;
  submitting: boolean;
  visibility: string;
}) => {
  const initialConfirm = {
    state: false,
    value: isExclusive,
  };

  const [confirm, setConfirm] = useState(initialConfirm);
  const onConfirm = () => {
    setExclusive(confirm.value);
    setConfirm(initialConfirm);
  };

  const onClose = () => setConfirm(initialConfirm);

  return (
    <>
      <div className="flex justify-between items-center">
        <Typography variant="body" size="large">
          {visibility}
        </Typography>
        <Switch
          checked={isExclusive}
          onChange={(ev, checked) =>
            setConfirm({ state: true, value: checked })
          }
          disabled={submitting}
          data-testid="toggleExclusive"
        />
      </div>
      <Modal
        isOpen={confirm.state}
        onClose={onClose}
        title="Are you sure you want to change this? You are changing between Platform and Exclusive business models for a creator."
        disableBackdropClick={true}
        modalClassName="w-full md:w-[600px]"
        hideCloseButton
      >
        <div className="flex flex-col gap-6">
          <Typography variant="body" size="large">
            {isExclusive
              ? "Warning: Performing this action will change the price for a creator's offering and place their content within our Platform experience. Please be very sure you want to do this."
              : 'Warning: This change will require the Creator to set their prices ahead of going live. Please be sure to set the price as soon as possible and double check that they are live.'}
          </Typography>
          <div className="flex justify-between">
            <Button onClick={onClose} variant="text" color="neutral">
              Cancel
            </Button>
            <Button onClick={onConfirm} color="neutral">
              I understand
            </Button>
          </div>
        </div>
      </Modal>
    </>
  );
};
